import { Tab, Tabs } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'

type TabValue = 'grants' | 'policies'

const AccessControlTabs = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const value: TabValue = location.pathname.startsWith('/access-control/policies') ? 'policies' : 'grants'

  return (
    <Tabs
      value={value}
      onChange={(_, next: TabValue) => navigate(next === 'grants' ? '/access-control' : '/access-control/policies')}
      sx={{ borderBottom: 1, borderColor: 'divider', px: 2 }}
    >
      <Tab label="Grants" value="grants" />
      <Tab label="Policies" value="policies" />
    </Tabs>
  )
}

export default AccessControlTabs
